import { useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { getData } from '../../DataAccessLayer';
import { summaries } from '../../DataAccessLayer/services';
import useResourceDetail from '../common/useResourceDetail';

function SummaryLayout() {
  const { summaryId } = useParams();
  const courseId = useSelector((state) => state.course.courseId);

  const {
    resource: summary,
    setResource: setSummary,
    isLoading,
    loadError,
  } = useResourceDetail({
    fetch: () => getData(summaries({ id: summaryId, courseId })),
    resourceLabel: 'summary note',
    id: summaryId,
  });

  return <Outlet context={{ summary, setSummary, isLoading, loadError }} />;
}

export default SummaryLayout;
